// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import { Validator } from 'vee-validate';
import { sync } from 'vuex-router-sync';

import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import vuexStore from './custom/especializacao/vuex/store';

// Importação de código de configuração/criação criados.
import plugins from './config/plugins';
import vuetify from './config/vuetify';
import directives from './config/directives';
import validations from './config/validations';
import theme from './config/theme/theme';
import interceptors from './config/interceptors';
import configRouter from './custom/especializacao/config/router';
import i18n from './config/i18n';
import Auth, { auth } from './config/sso/auth';
import dicionario from './common/functions/dicionario';

// Forçando o jQuery global
window.jQuery = require("jquery"); // eslint-disable-line
window.$ = window.jQuery; // eslint-disable-line
window.$logger = console;

plugins(Vue, Vuex, VueRouter);
directives(Vue);
theme(Vue);
validations(Validator);
interceptors(Vue);

Vue.config.ignoredElements = [ // CHANGE
  'angular-gauge-chart',
  'bar-chart-3d',
  'clustered-chart',
  'column-chart',
  'data-grid',
  'line-chart',
  'lined-bar-chart',
  'pie-chart',
  'sbx-dashboard',
];
Vue.config.productionTip = false;


// Importando o componente raíz onde a app será renderizada.
import App from './App'; // eslint-disable-line

// Verifica autenticacao no sso
auth.loginRequired().then(dicionario.carregar).then((resDicionario) => {
  // Só inicia o router após o Keycloak ter resolvido a sessão
  const store = new Vuex.Store(vuexStore);
  const router = configRouter(VueRouter);

  // Sincronização entre rotas e vuex.
  // Garante o estado da store em todas as páginas SPA.
  sync(store, router);
  const i18nData = i18n(Vue, resDicionario);
  i18nData.locale = 'pt-br';

  new Vue({ // eslint-disable-line no-new
    router,
    store,
    vuetify,
    i18n: i18nData,
    el: '#app',
    template: '<App/>',
    components: { App },
    created: () => {
      // Cria os interceptors para as requisicoes dos servicos
      auth.createInterceptors();
      // Registra o plugin $auth com as informacoes de sessao com o keycloak
      Vue.use(Auth);
    },
  });
}).catch((e) => {
  if (e.status && e.message && e.status === 403) {
    window.alert(e.message); // eslint-disable-line
  }
});



// WEBPACK FOOTER //
// ./src/main.js